/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForThreat extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForThreat.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForThreat>): ProgressDetailsForThreat {
        let obj = Object.assign(new ProgressDetailsForThreat(), model);
        ProgressDetailsForThreat.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForThreat>): ProgressDetailsForThreat {
        if (!model) return null;
        return ProgressDetailsForThreat.newInstance(<ProgressDetailsForThreat> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForThreat) {
        if (!obj) return;

        models.ProgressDetailsForThreat.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForThreat): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForThreat.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.by_location) {
            for (let val of this.by_location) {
                models.ProgressDetailsMessagePerLocation.fixupPrototype(val);
            }
        }
    }

    by_location: Array<models.ProgressDetailsMessagePerLocation>;

}
